import ReactDatePicker from 'react-datepicker'
import './style.scss'
import { InputBase, styled } from '@mui/material'
import { useCallback, useEffect, useState } from 'react'
import { completeDateString } from '../../../commons/inputSupporter'
import _ from 'lodash'
import { colorPalette } from '../../../style/colorPalette'
import { dateTimeV2Service } from '../../../../domain/value-object/DateTimeV2'

type DateTimeInputProps = {
  value?: Date
  initialValueOnCalendar?: Date
  onChange?: (value?: Date) => void
  onSelect: (value?: Date) => void
  placeholder?: string
  editable?: boolean
}
export const DateTimeInput = ({
  value,
  initialValueOnCalendar,
  onChange,
  onSelect,
  placeholder,
  editable = true,
}: DateTimeInputProps) => {
  const [changedByInput, setChangedByInput] = useState(false)
  const [calendarOpened, setCalendarOpened] = useState(false)

  useEffect(() => {
    setChangedByInput(false)
  }, [value])

  const onSelectCallback = useCallback(
    (value?: Date) => {
      if (!changedByInput) {
        onSelect(value)
      } else {
        setChangedByInput(false)
      }
    },
    [onSelect, changedByInput]
  )
  const onChangeCaptureCallback = useCallback(
    _.debounce(event => {
      const inputValue = event.target.value
      setChangedByInput(true)

      if (!inputValue) {
        // 値をクリアした時
        onSelect(undefined)
      }

      const value = dateTimeV2Service.newFromString(inputValue)
      if (value.toString() === 'Invalid Date') {
        return
      }
      const newValue = new Date(value)
      onSelect(newValue)
    }, 200),
    [changedByInput, onSelect]
  )

  return (
    <ReactDatePicker
      showTimeInput={true}
      selected={value || (calendarOpened ? initialValueOnCalendar : undefined)}
      dateFormat={'yyyy/MM/dd HH:mm:ss'}
      onChange={onChange}
      onSelect={onSelectCallback}
      placeholderText={placeholder || 'YYYY/MM/DD HH:mm:ss'}
      customInput={
        <TextInput
          onChangeCapture={onChangeCaptureCallback}
          onFocusCapture={() => setCalendarOpened(true)}
          onBlurCapture={() => setCalendarOpened(false)}
        />
      }
      popperPlacement="bottom-end"
      disabled={!editable}
      onKeyDown={e => {
        if (e.key === 'Escape') {
          e.stopPropagation()
          e.currentTarget.blur()
        }
      }}
      fixedHeight={true}
    />
  )
}

const TextInput = styled(InputBase)({
  width: '100%',
  color: colorPalette.monotone[10],
})
